import { atom, selector } from 'recoil'


const Layers = atom({
	key: "Layers",
	default: []
})

const LayerSelector = selector({
	key: "LayerSelector",
	get: ({ get }) => {
		return Layers
	},
	set: ({ set }, newValue) => {
		set(Layers, newValue)
	}
})

export { LayerSelector }
export default Layers